import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white border-b border-gray-100 py-3 mb-6" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center w-[160px]"
}
const _hoisted_5 = {
  key: 1,
  class: "flex-grow text-center"
}
const _hoisted_6 = { class: "text-xl font-serif text-gray-800 tracking-widest uppercase" }
const _hoisted_7 = {
  key: 2,
  class: "w-[160px]"
}

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DiamondNav',
  props: {
    title: {},
    showBack: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props

const goBack = () => {
  const lastSearch = localStorage.getItem('lastDiamondSearch')
  if (lastSearch) {
    window.location.href = lastSearch
  } else {
    // The main search is the current url without the certificates id
    let path = window.location.pathname
    if (path.endsWith('/')) {
      path = path.slice(0, -1)
    }
    const parts = path.split('/')
    parts.pop()
    window.location.href = parts.join('/') + '/'
  }
}

const backLabel = computed(() => {
  const lastSearch = localStorage.getItem('lastDiamondSearch')
  return lastSearch 
    ? 'components.diamonds.details.DiamondDetailsNav.backToSearch' 
    : 'components.diamonds.details.DiamondDetailsNav.backToOverview'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (__props.showBack)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("button", {
                onClick: goBack,
                class: "flex items-center text-sm text-gray-500 hover:text-brand-main transition-colors duration-200"
              }, [
                _cache[0] || (_cache[0] = _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "h-4 w-4 mr-2",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M10 19l-7-7m0 0l7-7m-7 7h18"
                  })
                ], -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t(backLabel.value)), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (__props.title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("h1", _hoisted_6, _toDisplayString(__props.title), 1)
            ]))
          : _createCommentVNode("", true),
        (__props.showBack)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})